import React from 'react';

const Home = () => (
  <div className="home">
    <h2>Welcome to my page</h2>
    <p>
      Lorem ipsum dolor sit amet consectetur adipisicing elit.
      Unde rem sit quisquam commodi accusantium itaque
      quam praesentium quas, libero cumque quasi inventore molestias
      tenetur laboriosam possimus blanditiis amet corporis eveniet
      odit? Vitae veniam reiciendis consectetur ipsa error perferendis
      fugit, quas numquam corrupti ipsum dolorem consequatur saepe debitis
      voluptates sed ratione iure magni cum harum. Asperiores, voluptatibus
      excepturi impedit sint pariatur tenetur, repellendus eligendi quas
      ullam ducimus libero totam mollitia? In illo fuga laboriosam asperiores temporibus
      consequatur, sit velit voluptatem. Consectetur maiores, non neque qui sequi autem
      quibusdam quo tenetur! Quos blanditiis aut explicabo harum minima deleniti nam
      quod totam corrupti!
    </p>
    <p>
      Lorem ipsum dolor sit amet consectetur adipisicing elit.
      Unde rem sit quisquam commodi accusantium itaque
      quam praesentium quas, libero cumque quasi inventore molestias
      tenetur laboriosam possimus blanditiis amet corporis eveniet
      odit? Vitae veniam reiciendis consectetur ipsa error perferendis
      fugit, quas numquam corrupti ipsum dolorem consequatur saepe debitis
      voluptates sed ratione iure magni cum harum. Asperiores, voluptatibus
      excepturi impedit sint pariatur tenetur, repellendus eligendi quas
      ullam ducimus libero totam mollitia? In illo fuga laboriosam asperiores temporibus
      consequatur, sit velit voluptatem. Consectetur maiores, non neque qui sequi autem
      quibusdam quo tenetur! Quos blanditiis aut explicabo harum minima deleniti nam
      quod totam corrupti!
    </p>
  </div>
);

export default Home;
